import { render, staticRenderFns } from "./CardTarjaEnqueteRedacaoSportv.vue?vue&type=template&id=2e48080a&scoped=true"
import script from "./CardTarjaEnqueteRedacaoSportv.vue?vue&type=script&lang=js"
export * from "./CardTarjaEnqueteRedacaoSportv.vue?vue&type=script&lang=js"
import style0 from "./CardTarjaEnqueteRedacaoSportv.vue?vue&type=style&index=0&id=2e48080a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e48080a",
  null
  
)

export default component.exports